import { enhance, handle } from "@grrr/hansel";
import { onDomReady } from "@grrr/ready";
import { svgInline } from "./modules/svg";
import { social } from "./modules/social";
import { autoLoad } from "./modules/autoload";
import { showItems } from "./modules/show_items";
import { shareCalendarFoldout } from "./modules/share_calendar";
import { followLinkAttribute } from "./modules/follow_link";
import { menu } from "./modules/menu";
import { carrouselEnhancer } from "./modules/carrousel";
import { adjustBackground, generalFixes } from "./modules/general";
import { iframeEnhancer } from "./modules/iframe";
import { subMenu } from "./modules/submenu";
import { activitiesInHeroEnhancer } from "./modules/activities";
import { newsletterClose, newsletterPopup } from "./modules/newsletter_popup";
import { isotopeEnhancer } from "./modules/isotope";

onDomReady(() => {
    enhance(document.documentElement, {
        svgInline,
        social,
        autoLoad,
        showItems,
        carrouselEnhancer,
        generalFixes,
        iframeEnhancer,
        subMenu,
        activitiesInHeroEnhancer,
        adjustBackground,
        newsletterPopup,
        isotopeEnhancer,
    });
    handle(document.documentElement, {
        shareCalendarFoldout,
        followLinkAttribute,
        menu,
        newsletterClose,
    });
});
